/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRecentlySoldItems_itemSearch = {
    readonly thinBrowseSoldResults: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly item: {
                    readonly serviceId: string | null;
                    readonly " $fragmentRefs": FragmentRefs<"SbSharedThinBrowseItemTrackingProvider_items" | "SharedItemTile_item">;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_itemSearch" | "SbSharedThinBrowseItemTrackingProvider_itemSearch">;
    readonly " $refType": "SbSharedRecentlySoldItems_itemSearch";
};
export type SbSharedRecentlySoldItems_itemSearch$data = SbSharedRecentlySoldItems_itemSearch;
export type SbSharedRecentlySoldItems_itemSearch$key = {
    readonly " $data"?: SbSharedRecentlySoldItems_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRecentlySoldItems_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRecentlySoldItems_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "thinBrowseSoldResultsConnection",
      "kind": "LinkedField",
      "name": "thinBrowseSoldResults",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "thinBrowseSoldResultsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemSearchResult",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "item",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "serviceId",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "SbSharedThinBrowseItemTrackingProvider_items"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "SharedItemTile_item"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedThinBrowseItemTrackingProvider_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'e878a13e905e6a156a385708280d32e5';
export default node;
